<template>
  <div>
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="flex flex-col gap-5 pt-5 px-5 lg:px-10 py-10">
          <div class="w-full h-full py-5 flex flex-col gap-5">
            <div class="flex justify-between">
              <h2 class="text-xl font-semibold" >
                Total Departments -
                <span >{{ count_list || 0 }}</span>
                
              </h2>
              <router-link :to="{ name: 'AdminDashboards' }">
                <button class="bg-blues text-white py-1 px-3 rounded-lg">
                  Back
                </button>
              </router-link>
            </div>
            <div class="flex">
              <form
                @submit.prevent="searchUserValue"
                class="flex w-full md:w-auto"
              >
                <input
                  type="text"
                  placeholder="Search here"
                  v-model="searching"
                  @input="searchUserValue"
                  class="px-4 py-2 rounded-l-md border border-gray-300 focus:outline-none"
                />
                <button class="bg-blues text-white px-4 py-2 rounded-r-md">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </button>
              </form>
            </div>

            <div class="flex justify-between">
              <h1 class="text-lg font-semibold dark_text">Department List</h1>
            </div>
            <div class="hidden">
              <form
                @submit.prevent="filterList"
                class="flex flex-col lg:flex-row flex-wrap gap-4"
              >
                <select
                  name="semester"
                  id="semester"
                  v-model="selectsemester"
                  class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold uppercase leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="" disabled selected>Semester</option>
                </select>

                <select
                  name="course"
                  id="course"
                  v-model="selectPatch"
                  class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold uppercase leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="" disabled selected>Batch</option>
                  <option
                    v-for="batch in batchs"
                    :key="batch.year"
                    :value="batch.id"
                  >
                    {{ batch.year }}
                  </option>
                </select>

                <select
                  name="subject_code"
                  id="subject_code"
                  v-model="selectdepartment"
                  class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold uppercase leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="" disabled selected>Department</option>
                  <option
                    v-for="department in departments"
                    :key="department.name"
                    :value="department.id"
                  >
                    {{ department.name }}
                  </option>
                </select>

                <select
                  name="section"
                  id="section"
                  v-model="selectprogram"
                  class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold uppercase leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="" disabled selected>Program</option>
                  <option
                    v-for="program in programs"
                    :key="program.name"
                    :value="program.id"
                  >
                    {{ program.name }}
                  </option>
                </select>

                <select
                  name="session"
                  id="session"
                  v-model="selectsession"
                  class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold uppercase leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="" disabled selected>Session</option>
                </select>
                <select
                  name="session"
                  id="session"
                  v-model="selectsection"
                  class="bg-white rounded-md border border-gray-300 px-3 py-2 text-xs font-semibold uppercase leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="" disabled selected>Section</option>
                </select>

                <div class="flex items-center gap-3">
                  <button
                    type="submit"
                    class="bg-blue-600 text-white rounded-md px-4 py-2 text-xs font-semibold uppercase hover:bg-blue-700 transition"
                  >
                    Submit
                  </button>
                  <button
                    type="button"
                    @click="clearFilters"
                    class="text-blue-600 underline flex items-center text-xs font-semibold gap-1"
                  >
                    <img
                      src="@/assets/attendance/cancel.webp"
                      alt="Clear"
                      class="w-3 h-3 object-contain"
                    />
                    Clear All
                  </button>
                </div>
              </form>
            </div>

            <div class="w-full overflow-scroll">
              <table class="min-w-full">
                <thead>
                  <tr
                    class="text-left bg-blues text whitespace-nowrap text-sm"
                  >
                    <th class="px-6 py-3">S.No</th>
                    <th class="px-6 py-3">Name</th>
                    <th class="px-6 py-3">Shortname</th>
                    <th class="px-6 py-3">Code</th>
                  </tr>
                </thead>
                <tbody v-if="loading" class="bg-[#e5e7eb] w-fit">
                  <tr class="w-full">
                    <td colspan="12" class="text-center py-6">
                      <div class="flex items-center justify-center">
                        <img src="@/assets/attendance/loading.gif" alt="" />
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <template v-if="departments.length > 0">
                    <tr
                      v-for="(list, index) in departments"
                      :key="index"
                      class="border-b border-[#afdaec] text-left whitespace-nowrap text-sm"
                    >
                      <td class="px-6 py-3">
                        {{ (currentPage - 1) * perPage + index + 1 }}
                      </td>

                      <td class="px-6 py-3">
                        <span v-if="list.name != null">{{ list.name }}</span
                        ><span v-else>---</span>
                      </td>
                      <td class="px-6 py-3">
                        <span v-if="list.short_name != null">{{
                          list.short_name
                        }}</span
                        ><span v-else>---</span>
                      </td>
                      <td class="px-6 py-3">
                        <span v-if="list.code != null">{{ list.code }}</span
                        ><span v-else>---</span>
                      </td>
                    </tr>
                  </template>
                  <tr v-else>
                    <td colspan="11" class="px-6 py-3 text-center">
                      No Data Found
                    </td>
                  </tr>
                </tbody>
                <!-- <tfoot>
                  <tr>
                    <td colspan="11" class="p-6 bg-[#18469d]"></td>
                  </tr>
                </tfoot> -->
                <tfoot v-if="totalPages > 1" class="">
                  <tr>
                    <td colspan="7" class="bg-blues">
                      <div class="flex justify-center py-4 space-x-2">
                        <button
                          class="px-3 py-2 bg-gray-200 rounded disabled:opacity-50"
                          :disabled="currentPage === 1"
                          @click="prevPage"
                        >
                          &laquo;
                        </button>

                        <button
                          v-for="page in paginationRange"
                          :key="page"
                          class="px-3 py-2 rounded"
                          :class="{
                            'bg-blue-800 text-white': currentPage === page,
                            'bg-white border border-gray-400 text-gray-800':
                              currentPage !== page,
                          }"
                          @click="changePage(page)"
                        >
                          {{ page }}
                        </button>

                        <button
                          class="px-3 py-2 bg-gray-200 rounded disabled:opacity-50"
                          :disabled="currentPage >= totalPages"
                          @click="nextPage"
                        >
                          &raquo;
                        </button>
                      </div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "@/components/Admin/SideBar.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      //   loading: true,
      messages: {
        text: "",
        type: "null",
      },
      selectsemester: "",
      selectPatch: "",
      selectdepartment: "",
      selectprogram: "",
      selectsession: "",
      selectsection: "",
      departments: [],

      count_list: "",
       currentPage: 1,
      totalPages: 1,
      perPage: 10,
      searching: "",
    };
  },
  components: {
    SideBar,
    FlashMessage,
  },
  async created() {
    await this.departmentget();
  },

  computed: {
    ...mapGetters(["userInfo"]),
    paginationRange() {
      const totalPages = this.totalPages;
      const currentPage = this.currentPage;
      let pages = [];

      if (totalPages <= 5) {
        pages = [...Array(totalPages).keys()].map((x) => x + 1);
      } else {
        if (currentPage > 3) pages.push(1);
        if (currentPage > 4) pages.push("...");

        const startPage = Math.max(2, currentPage - 1);
        const endPage = Math.min(totalPages - 1, currentPage + 1);

        for (let i = startPage; i <= endPage; i++) {
          pages.push(i);
        }

        if (currentPage < totalPages - 3) pages.push("...");
        if (currentPage < totalPages - 2) pages.push(totalPages);
      }

      return pages;
    },
  },
  methods: {
    async departmentget() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/department-filter-list/?Key=${this.userInfo.token_key}&page=${this.currentPage}`
        )
        .then((res) => {
          if (res.data.data.status == 200) {
            this.departments = res.data.data.data;
            this.count_list = res.data.total;
            this.totalPages = Math.ceil(res.data.total / this.perPage);
            console.log("  this.department123", this.departments);
          }
        });
    },
    async searchUserValue() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/department-filter-list/?search=${this.searching}&Key=${this.userInfo.token_key}&page=${this.currentPage}`
        )
        .then((res) => {
          if (res.data.data.status == 200) {
            this.departments = res.data.data.data;
            this.count_list = res.data.total;
            this.totalPages = Math.ceil(res.data.total / this.perPage);
            console.log("  this.department123", this.departments);
          }
        });
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.departmentget();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.departmentget();
      }
    },
    changePage(page) {
      if (page !== "..." && page !== this.currentPage) {
        this.currentPage = page;
        this.departmentget();
      }
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
